module.exports = __webpack_public_path__ + "static/media/wizualizacja-139.d9764264.png";